import React from "react"
import { InputF, TextareaF, SelectF } from '../../elements/FormFields'
import { CalendarDay2 } from '../../elements/DayPicker/DayPicker2'

export class EditableCell extends React.Component {
    handleChange = changeEvent => {
        this.setState({date: changeEvent.target.value})
        //this.props.onChange(changeEvent)
    }
    render() {
        const tp = this.props
        const tpc = tp.cellData
        if (tpc.type === "date"){
            return (
               <td className="form-cell-box-inline">
                 {/*<label htmlFor={tpc.id}>{PImicroLegend[tpc.name] }</label>*/}
                 <CalendarDay2
                     tpc = {tpc}
                     value = {tpc.value}
                     selected={new Date()}
                     onChange={this.handleChange}
                     handleChangeDate={tp.onProductTableDate} // {this.handleChangeDate}
                 />
               </td>
             )
        }  
        if (tpc.type === "select") // "Simple" select provides special logic
            return <td style={{padding: 0, borderTop: 0}}><SelectF tpc={tpc} tp={tp} /></td>
            
        if (tpc.type === "textarea")
            return <td style={{padding: 0, borderTop: 0}}><TextareaF tpc={tpc} tp={tp} /></td>

        // input    
        return (<td style={{padding: 0, borderTop: 0}}> <InputF tpc={tpc} tp={tp} /> </td>)
  
    }
  }

